/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'
import { commissionRateSettings } from '../../domain/model/site_referrer/CommissionRateSetting'
import { estimateAccommodationFee, estimateCommissionFee } from '../../domain/model/reservation/EstiimateAccommodationFee'

const _DailyClosingReservationState = {
  id: null,
  daily_closing_head_id: null,
  reservation_id: null,
  rsvn_sales: 0,
  ota_comsn: 0,
  rsvn_pay_comsn: 0,
  rsvn_pay_code: '',
  site_referrer_id: null,
  accom_tax: 0,
  accom_pay_comsn: 0,
  accom_pay_code: null,
  reservation: null
}

class DailyClosingReservationState extends Record(_DailyClosingReservationState) {
  mergeModel(model) {
    return this.merge(model)
  }

  toRequestBody() {
    return {
      id: this.id,
      daily_closing_head_id: this.daily_closing_head_id,
      reservation_id: this.reservation_id,
      rsvn_sales: this.rsvn_sales || 0,
      ota_comsn: this.ota_comsn || 0,
      rsvn_pay_comsn: this.rsvn_pay_comsn || 0,
      rsvn_pay_code: this.rsvn_pay_code,
      site_referrer_id: this.site_referrer_id,
      accom_pay_comsn: this.accom_pay_comsn || 0,
      accom_pay_code: this.accom_pay_code
    }
  }

  buildBy(reservation, site_referrer_options, transaction_commissions) {
    return this.setReservation(reservation, site_referrer_options).setPayment(transaction_commissions[0])
  }

  // 以下 private
  setReservation(reservation, site_referrer_options) {
    let commission = reservation.commission
    let site_referrer_id = ''
    const site_referrer = reservation.site_referer
    if (!site_referrer || !site_referrer_options) {
      return this.merge({
        reservation_id: reservation.id,
        rsvn_sales: reservation.accommodation_fee,
        ota_comsn: reservation.commission,
        reservation: reservation
      })
    }

    const site_referrer_option = site_referrer_options.find(option => {
      const option_name = option.label.toLowerCase()
      const site_referrer_name = site_referrer.toLowerCase()
      // FIXME: サーバーサイドに判定ロジックを移動する
      // 前方一致で一致させる
      if (option_name.indexOf(site_referrer_name) !== -1) {
        return true
      }

      // FIXME: 一休comの例外対応
      if (option_name.indexOf('一休') !== -1 && site_referrer_name.indexOf('一休') !== -1) {
        return true
      }

      return false
    })

    let estimateFee = reservation.accommodation_fee
    if (!!site_referrer_option) {
      site_referrer_id = site_referrer_option.value

      // OTA手数料率から宿泊料金を設定
      const site_referrer_name = site_referrer_option.label
      const commissionRate = commissionRateSettings[site_referrer_name]
      estimateFee = estimateAccommodationFee(reservation.accommodation_fee, commissionRate)
      commission = estimateCommissionFee(reservation.accommodation_fee, commissionRate)
    }

    return this.merge({
      reservation_id: reservation.id,
      rsvn_sales: estimateFee,
      ota_comsn: commission,
      site_referrer_id: site_referrer_id,
      reservation: reservation
    })
  }

  setPayment(transaction_commissions) {
    if (transaction_commissions && transaction_commissions.length > 0) {
      const transaction_commission = transaction_commissions[0]
      return this.merge({
        accom_pay_comsn: transaction_commission.amount,
        accom_pay_code: transaction_commission.payment_code
      })
    }
    return this
  }
}

export { DailyClosingReservationState }
